import type { GQL_ID } from '@@partner:types:graphql'
import type { LoyaltyCouponSeries, LoyaltyCouponSeriesTranslation } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS } from '@@partner:graphql/shortcuts'

export interface CreateLoyaltyCouponSeriesInput {
  code: string
  title: string
  description?: string
  image_file_id?: GQL_ID
  validFrom?: number | null
  validUntil?: number | null
  i18n?: LoyaltyCouponSeriesTranslation[]

  canBeActivated: Boolean
}

export interface UpdateLoyaltyCouponSeriesInput {
  code?: string
  title?: string
  description?: string
  image_file_id?: GQL_ID
  validFrom?: number | null
  validUntil?: number | null
  i18n?: LoyaltyCouponSeriesTranslation[]
  
  canBeActivated: Boolean
}

export interface CreateLoyaltyCouponSeriesMutation {
  loyaltyCouponSeries: LoyaltyCouponSeries
}

export interface CreateLoyaltyCouponSeriesMutationVariables {
  input: CreateLoyaltyCouponSeriesInput
}

export interface UpdateLoyaltyCouponSeriesMutation {
  loyaltyCouponSeries: LoyaltyCouponSeries
}

export interface UpdateLoyaltyCouponSeriesMutationVariables {
  id: GQL_ID
  input: UpdateLoyaltyCouponSeriesInput
}

export interface DeleteLoyaltyCouponSeriesMutation {
  success: boolean
}

export interface DeleteLoyaltyCouponSeriesMutationVariables {
  id: GQL_ID
}

export const GQL_MUTATION_CREATE_LOYALTY_COUPON_SERIES = gql`
  mutation($input: CreateLoyaltyCouponSeriesInput!) {
    loyaltyCouponSeries: createLoyaltyCouponSeries(input: $input) {
      ${SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS}
    }
  }
`

export const GQL_MUTATION_UPDATE_LOYALTY_COUPON_SERIES = gql`
  mutation($id: ID!, $input: UpdateLoyaltyCouponSeriesInput!) {
    loyaltyCouponSeries: updateLoyaltyCouponSeries(id: $id, input: $input) {
      ${SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS}
    }
  }
`

export const GQL_MUTATION_DELETE_LOYALTY_COUPON_SERIES = gql`
  mutation($id: ID!) {
    success: deleteLoyaltyCouponSeries(id: $id)
  }
`

export const useMutateCreateLoyaltyCouponSeries = () =>
  useMutation<CreateLoyaltyCouponSeriesMutation, CreateLoyaltyCouponSeriesMutationVariables>(
    GQL_MUTATION_CREATE_LOYALTY_COUPON_SERIES
  )

export const useMutateUpdateLoyaltyCouponSeries = () =>
  useMutation<UpdateLoyaltyCouponSeriesMutation, UpdateLoyaltyCouponSeriesMutationVariables>(
    GQL_MUTATION_UPDATE_LOYALTY_COUPON_SERIES
  )

export const useMutateDeleteLoyaltyCouponSeries = () =>
  useMutation<DeleteLoyaltyCouponSeriesMutation, DeleteLoyaltyCouponSeriesMutationVariables>(
    GQL_MUTATION_DELETE_LOYALTY_COUPON_SERIES
  )
